import {
  UI_API_METHOD_TYPES,
  type UiCompletePostcallRequest,
  type UiSetPostcallStyleRequest,
} from '@sdk/api/modules/ui/types.ui'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * Completes the postcall stage (with successful submission or not)
 *
 * @example
 * useUi().completePostcall({ was_successfully_submitted: true })
 */
export async function completePostcall(payload: UiCompletePostcallRequest): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, UI_API_METHOD_TYPES.UI_COMPLETE_POSTCALL, payload)
}

/**
 * Cancels current meeting and the event remains unrealized (like it never happened).
 *
 * @example
 * useUi().cancelMeeting()
 */
export async function cancelMeeting(): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, UI_API_METHOD_TYPES.UI_CANCEL_MEETING)
}

/**
 * Resumes the meeting and attempts to go at the last presented route / component.
 *
 * @example
 * useUi().resumeMeeting()
 */
export async function resumeMeeting(): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, UI_API_METHOD_TYPES.UI_RESUME_MEETING)
}

/**
 * Ends current meeting and shows postcall form.
 *
 * @example
 * useUi().stopMeeting()
 */
export async function stopMeeting(): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, UI_API_METHOD_TYPES.UI_STOP_MEETING)
}

/**
 * Mark the postcall form as possible to submit by the user.
 *
 * @deprecated
 * @example
 * useUi().enablePostcallSubmit()
 */
export async function enablePostcallSubmit(): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, UI_API_METHOD_TYPES.UI_ENABLE_POSTCALL_SUBMIT)
}

/**
 * Mark the postcall form as **not** possible to submit by the user. Useful while processing the form data.
 *
 * @deprecated
 * @example
 * useUi().disablePostcallSubmit()
 */
export async function disablePostcallSubmit(): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, UI_API_METHOD_TYPES.UI_DISABLE_POSTCALL_SUBMIT)
}

/**
 * Change the height of the postcall form.
 *
 * @example
 * useUi().setPostcallStyle({ height: 100 })
 */
export async function setPostcallStyle(payload: UiSetPostcallStyleRequest): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, UI_API_METHOD_TYPES.UI_SET_POSTCALL_STYLE, payload)
}
